import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getBooking, getIsSubmitting, getIsValid, getAreTermsReaded } from '../../../data/booking/selectors/booking';
import { bindActionCreators } from 'redux';
import { cancel, submit, termsAccepted, termsReaded, termsRejected } from '../../../data/booking/actions/booking';
import SubmitForm from '../components/SubmitForm';

class SubmitFormContainer extends Component {
    static propTypes = {
        booking: PropTypes.object,
        isLoading: PropTypes.bool,
        areTermsReaded: PropTypes.bool,
        isValid: PropTypes.bool,
        submit: PropTypes.func,
        cancel: PropTypes.func,
        termsReaded: PropTypes.func,
        termsAccepted: PropTypes.func
    };

    handleSubmit() {
        this.props.submit();
    }

    handleClickCancel(e) {
        e.preventDefault();

        this.props.cancel();
    }

    handleBottomReached() {
        this.props.termsReaded();
    }

    handleTermsAccepted(e) {
        if(e.target.checked) {
            this.props.termsAccepted();
        } else {
            this.props.termsRejected();
        }
    }

    render() {
        const { booking, isLoading, isValid, areTermsReaded } = this.props;

        return (
            <SubmitForm
                data={booking}
                isLoading={isLoading}
                areTermsReaded={areTermsReaded}
                //areTermsReaded={true}
                isValid={isValid}
                onSubmit={::this.handleSubmit}
                onClickCancel={::this.handleClickCancel}
                onBottomReached={::this.handleBottomReached}
                onTermsAccepted={::this.handleTermsAccepted}
            />
        );
    }
}

export default connect(
    state => ({
        booking: getBooking(state.booking),
        isLoading: getIsSubmitting(state.booking),
        isValid: getIsValid(state.booking),
        areTermsReaded: getAreTermsReaded(state.booking)
    }),
    dispatch => bindActionCreators({ submit, cancel, termsAccepted, termsReaded, termsRejected }, dispatch)
)(SubmitFormContainer);
